import { Api as MicromagApi } from '@micromag/data';

import QuizApi from './Quiz';
import ContributionsApi from './Contributions';

class ViewerApi extends MicromagApi {
    constructor(opts = {}) {
        const options = {
            baseUrl: '/',
            ...opts,
        };
        super(options);
        this.quiz = new QuizApi(options);
        this.contributions = new ContributionsApi(options);
    }
}

export default ViewerApi;
